import * as editorErrTypes from 'config/editErrorTypes';

/**
 * 取得方案 API 可預期的 MESSAGE
 * @typedef {Object} GET_PLAN_ORDER_API_RESPONSE
 * @see
 */
export const GET_PLAN_ORDER_API_RESPONSE = {
    // 1. 活動時間（含子模組）沒有設定
    // 2. 活動狀態是結束
    // 3. 活動結束時間小於等於現在時間
    [editorErrTypes.VALID_DATETIME_EMPTY]: (payload = {}) =>
        payload?.message === 'Promotion settings error - Valid Datetime Empty' &&
        payload?.code === 'PMS-V0-F0' &&
        payload?.data[0].length > 0,
    [editorErrTypes.VALID_DATETIME_EXPIRED]: (payload = {}) =>
        payload?.message === 'Promotion settings error - Valid Datetime Empty' &&
        payload?.code === 'PMS-V0-F0' &&
        payload?.data[0].length === 0,
    // 活動結束時間小於活動起始時間
    [editorErrTypes.VALID_DATETIME_SETTING_ERROR]: (payload = {}) =>
        payload?.message === 'Promotion settings error - Datetime' && payload?.code === 'PMS-V0-F0',
    // 如果綁定的訂單結束時間小於活動設定的結束時間，代表需要續約，但方案訂單不是年約不可以跨約或續約
    [editorErrTypes.VALID_DATETIME_RANGE_NOT_IN_PLAN]: (payload = {}) =>
        payload?.message === 'Order datetime and type valid failed.' &&
        payload?.code === 'SPPO-V0-F0'
};

// 這隻只有關聯點數池的活動才會有作用
export const PROMO_ONLINE_PRE_CHECK_API_RESPONSE = {
    [editorErrTypes.TASK_HAS_NOT_BOUND_VALID_PROMOTION]: (payload = {}) => {
        return (
            payload?.message === 'Task has not bound a valid promotion' &&
            payload?.code === 'TSS-V0-F0'
        );
    },
    // 兌獎模組應要擁有此設定，但查無設定
    [editorErrTypes.REDEEM_POINT_POOL_UUID_NOT_FOUND]: (payload = {}) => {
        return (
            payload?.message === 'Setting not found - redeem withdraw uuid' &&
            payload?.code === 'PMS-V0-F0'
        );
    },
    // 關聯的點數池狀態為停用
    [editorErrTypes.POINT_POOL_STATUS_IS_PAUSE]: (payload = {}) => {
        return payload?.message === 'Status is wrong' && payload?.code === 'PSPM-V0-F0';
    },
    // 關聯的點數池查無資料（可能被刪除或儲存時資料有錯）
    [editorErrTypes.DEDUCTED_POINT_POOL_ID_NOT_FOUND]: (payload = {}) => {
        return payload?.message === 'Data empty' && payload?.code === 'PSPM-R1-FNF1';
    },
    // 兌換獎品用的點數池編號設定，查無對應的資料
    [editorErrTypes.REDEEM_POINT_POOL_NOT_FOUND]: (payload = {}) => {
        return payload?.message === 'Data empty - pool' && payload?.code === 'PSPM-R1-FNF1';
    },
    // 獎品為活動點數獎，但沒有關聯點數池
    [editorErrTypes.REWARD_POINT_POOL_ID_NOT_FOUND]: (payload = {}) => {
        return payload?.message === 'Setting is wrong' && payload?.code === 'PSPM-V0-F0';
    },
    // 參加限制扣點有設定點數池，但沒有設定扣多少點
    [editorErrTypes.VERIFY_DEDUCTED_POINT_QUANTITY_IS_EMPTY]: (payload = {}) => {
        return (
            payload?.message === 'Transaction withdraw quantity is wrong' &&
            payload?.code === 'PMS-V0-F0'
        );
    }
};

export const PROMO_STATUS_API_RESPONSE = {
    // 活動有關聯點數池，但點數池尚未啟用
    [editorErrTypes.POINT_POOL_STATUS_INVALID]: (payload = {}) =>
        payload?.message === 'Point system data valid failed - status' &&
        payload?.code === 'PSP-V0-F0',
    [editorErrTypes.POINT_PLAN_DATE_INVALID]: (payload = {}) =>
        payload?.message === 'Point system data valid failed - valid date' &&
        payload?.code === 'PSP-V0-F0',
    [editorErrTypes.POINT_POOL_DELETED]: (payload = {}) =>
        payload?.message === 'Point system data valid failed - deleted' &&
        payload?.code === 'PSP-V0-F0',
    [editorErrTypes.POINT_SYSTEM_VALID_FAILED_NO_RELATION]: (payload = {}) =>
        payload?.message === 'Point system valid failed - not relation' &&
        payload?.code === 'PSPR-V0-F0',
    [editorErrTypes.POINT_SYSTEM_VALID_FAILED_NO_PERMISSION]: (payload = {}) =>
        payload?.message === 'Point system valid failed - no permission' &&
        payload?.code === 'PSP-V0-F0',
    [editorErrTypes.PERMISSION_DENIED]: (payload = {}) =>
        payload?.message === 'Permission denied' && payload?.code === 'Permission denied'
};

export const PROMO_ONLINE_TEST_DATA_API_RESPONSE = {
    [editorErrTypes.PROMOTION_STATUS_INVALID]: (payload = {}) =>
        payload?.message === 'promotion status invalid' && payload?.code === 'PM-V0-F0'
};
